// frontend/src/pages/Admin/AboutManagement.jsx
import React, { useState, useEffect } from 'react';
import './AdminStyles.css';
import { aboutService } from '../../services/aboutService';
import ImageUpload from './components/ImageUpload';

const AboutManagement = () => {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    title: 'О парке',
    description: '',
    coverImage: null,
    gallery: []
  });

  useEffect(() => {
    loadAbout();
  }, []);

  const loadAbout = async () => {
    try {
      const data = await aboutService.getAbout();
      setAbout(data.about);
      setFormData({
        title: data.about.title,
        description: data.about.description,
        coverImage: null,
        gallery: []
      });
    } catch (error) {
      console.error('Ошибка загрузки информации о парке:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCoverSelect = (file) => {
    setFormData(prev => ({ ...prev, coverImage: file }));
  };

  const handleGallerySelect = (files) => {
    setFormData(prev => ({ ...prev, gallery: files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('description', formData.description);
    
    if (formData.coverImage instanceof File) {
      formDataToSend.append('coverImage', formData.coverImage);
    }
    
    if (formData.gallery.length > 0) {
      formData.gallery.forEach(file => {
        formDataToSend.append('gallery', file);
      });
    }

    try {
      await aboutService.updateAbout(formDataToSend);
      await loadAbout();
      alert('Информация успешно сохранена');
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      alert('Ошибка при сохранении');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="admin-loading">Загрузка...</div>;
  }

  return (
    <div className="admin-content">
      <div className="admin-header">
        <h2>Редактирование страницы "О парке"</h2>
      </div>

      <form onSubmit={handleSubmit} className="admin-form">
        <div className="form-group">
          <label>Заголовок</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Описание</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="10"
            required
          />
        </div>

        <ImageUpload
          label="Обложка"
          onImageSelect={handleCoverSelect}
          currentImage={about?.coverImage}
        />

        <ImageUpload
          label="Галерея изображений"
          onImageSelect={handleGallerySelect}
          multiple={true}
        />

        {about?.images && about.images.length > 0 && (
          <div className="current-gallery">
            <h4>Текущая галерея</h4>
            <div className="gallery-preview">
              {about.images.map((img, index) => (
                <div key={index} className="gallery-item">
                  <img src={img.imageUrl} alt={`Gallery ${index}`} />
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="form-actions">
          <button 
            type="submit" 
            className="admin-button primary"
            disabled={saving}
          >
            {saving ? 'Сохранение...' : 'Сохранить изменения'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AboutManagement;